module.exports = __webpack_public_path__ + "static/media/solar-panel.981632ef.png";